import { render, staticRenderFns } from "./Sugestao.vue?vue&type=template&id=06dfe3a0"
import script from "./Sugestao.vue?vue&type=script&lang=js"
export * from "./Sugestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports